 export const robots =[

{
	id:1,
	name:'rogers',
	email:'cap@fakemail.com',
	username:'captain'
},
{
	id:2,
	name:'tony',
	email:'tony@fakemail.com',
	username:'iron man'
},
{
	id:3,
	name:'Thor',
	email:'thor@fakemail.com',
	username:'mighty'
},
{
	id:7,
	name:'shivam',
	email:'thor@fakemail.com',
	username:'mighty'
},
{
	id:4,
	name:'amit',
	email:'tony@fakemail.com',
	username:'iron man'
},
{
	id:5,
	name:'Thor',
	email:'thor@fakemail.com',
	username:'mighty'
},
{
	id:6,
	name:'Devu',
	email:'thor@fakemail.com',
	username:'mighty'
},
{
	id:41,
	name:'keshav',
	email:'tony@fakemail.com',
	username:'iron man'
},
{
	id:42,
	name:'tony stark',
	email:'tony@fakemail.com',
	username:'iron man'
},
{
	id:43,
	name:'tony stark',
	email:'tony@fakemail.com',
	username:'iron man'
},
{
	id:4151,
	name:'tony stark',
	email:'tony@fakemail.com',
	username:'iron man'
},
]
